import { css } from '@emotion/react';
import Image from 'next/image';
import { styled } from '@mui/material';

import { Button } from '@/components/Button/Button';
import { RoleTag } from '@/components/RoleTag';
import SocialShare from '@/domains/blogs/widgets/SocialShare/SocialShare';

export const Wrapper = styled('div')`
  grid-area: social;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  margin-bottom: 1.875rem;
  @media screen and (min-width: 640px) {
    gap: 1.5rem;
  }
`;

export const AffiliateIcon = styled(Image)`
  overflow: hidden;
  height: 24px;
  width: 24px;
`;

type AffiliatedStyledButtonProps = {
  isInternal?: boolean;
  bottom: boolean;
  top: boolean;
};

const AffiliatedStyles = ({ bottom, isInternal, top }) => css`
  border: 1px solid #e1e1e1;
  border-bottom-width: ${bottom ? 1 : 0}px;
  border-top-width: ${top ? 1 : 0}px;
  display: flex;
  padding-right: 0.625rem;
  padding-left: 0.625rem;
  gap: 0.625rem;
  color: ${isInternal ? '#5FA3A9' : '#4F4F4F'};
  border-top-left-radius: ${top ? 1.7 : 0}rem;
  border-top-right-radius: ${top ? 1.7 : 0}rem;
  border-bottom-left-radius: ${bottom ? 1.7 : 0}rem;
  border-bottom-right-radius: ${bottom ? 1.7 : 0}rem;
  background-color: transparent;
  font-size: 1rem;
  font-weight: 400;
`;

export const AffiliatedStyledButton = styled(
  Button,
)<AffiliatedStyledButtonProps>(({ bottom, isInternal, top }) =>
  AffiliatedStyles({ bottom, isInternal, top }),
);

export const AffiliatedStyledLink = styled(Button)<AffiliatedStyledButtonProps>(
  ({ bottom, isInternal, top }) =>
    AffiliatedStyles({ bottom, isInternal, top }),
);
export const ButtonsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;
export const Price = styled('span')`
  margin-left: auto;
`;

export const ComissionTag = styled(RoleTag)`
  display: flex;
  justify-content: center;
  color: #aeadad;
  width: 100%;
  text-align: center;
  @media screen and (min-width: 640px) {
    font-size: 0.75rem;
    padding: 0.75rem;
  }
  @media screen and (min-width: 768px) {
    font-size: 0.75rem;
    padding: 0.75rem;
  }
`;

export const SocialShareWrapper = styled('div')`
  display: none;
  @media screen and (min-width: 640px) {
    display: block;
  }
`;

export const PurchaseSocialShare = styled(SocialShare)`
  margin-top: 1.125rem;
  gap: 1.6rem;
  align-items: baseline;
  flex-wrap: wrap;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    gap: 2.9rem;
  }
  ${({ theme }) => theme.breakpoints.up('xl')} {
    gap: 3rem;
  }
`;
